const openSearch = () => {
    const openSearch = document.querySelector('.search__open');
    if(openSearch) {
        openSearch.addEventListener('click', () => {
            if(openSearch.classList.contains('search__close')) {
                openSearch.children[0].src = './icons/header/search.svg';
            } else {
                openSearch.children[0].src = './icons/header/close.svg';

            }
            openSearch.classList.toggle('search__close');
            openSearch.nextElementSibling.classList.toggle('search_active');
        })
    }
}

export default openSearch;